import { show, distanceDisplayCondition, width, material, positions } from '../mixinProps'

/**
 * vc-graphics-polyline base props mixins
 */
export default {
  mixins: [show, distanceDisplayCondition, width, material, positions]
}
